export default "__VITE_ASSET__aec9d49a__"